<template>
  <div class="main">
    <div class="jdbox" v-loading="loading">
      <div class="jdtop" v-if="hotNewsTop.newsList">
        <a
          href="javascript:;"
          :title="hotNewsTop.newsList[1].title"
          @click="
            detail(
              hotNewsTop.newsList[1].newsId,
              hotNewsTop.columnPath,
              hotNewsTop.newsList[1].columnId,
              2
            )
          "
        >
          <div>{{ hotNewsTop.newsList[1].title }}</div>
        </a>
      </div>
      <div class="jdcontent" v-if="hotNewsTop.newsList">
        <div class="img">
          <a
            href="javascript:;"
            :title="hotNewsTop.newsList[0].title"
            @click="
              detail(
                hotNewsTop.newsList[0].newsId,
                hotNewsTop.columnPath,
                hotNewsTop.newsList[0].columnId,
                2
              )
            "
          >
            <img :src="hotNewsTop.newsList[0].coverUrl" />
          </a>
          <div class="mask1">
            <div>{{ hotNewsTop.newsList[0].title }}</div>
          </div>
        </div>
        <div class="news">
          <div class="tab">
            <div
              class="sub-tab"
              :class="{ active: index == tabIndex }"
              v-for="(tab, index) in tabs"
              :key="index"
              @mouseenter="enter(tab.id, index)"
            >
              {{ tab.label }}
            </div>
          </div>
          <div class="tab-content">
            <div
              class="sub-content"
              v-for="(item, index) in rightNewsList.newsList.slice(0,9)"
              :key="index"
              @click="detail(item.newsId, rightNewsList.columnPath, item.columnId, tabIndex+1)"
            >
              <a href="javascript:;"  :title="item.title">
                <div
                  class="title3"
                  style="
                    margin-top: 22px;
                    font-size: 20px;
                    font-weight: bold;
                    color: #333333;
                  "
                  v-if="index == 0 || index == 3 || index == 6"
                >
                  {{ item.title.length > 31 ? item.title.slice(0,31) + "..." : item.title }}
                </div>
                <div
                  class="title4"
                  style="
                    margin-top: 13px;
                    font-size: 18px;
                    color: #555555;
                    font-weight: 400;
                  "
                  v-else
                >
                  {{ item.title.length > 31 ? item.title.slice(0,31) + "..." : item.title }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jdgg" v-if="banner.length >= 1">
      <a :href="banner[0].bannerUrl" target="_blank">
        <img :src="banner[0].bannerPic" />
      </a>
    </div>
    
    <div class="jdf1">
      <common-card :title="workNewsList.columnName">
        <div class="news" v-if="workNewsList.newsList">
          <ul>
            <li
              v-for="(item, index) in workNewsList.newsList.slice(0,6)"
              :key="index"
              @click="detail(item.newsId, workNewsList.columnPath, item.columnId, 1)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img" style="width: 100%" v-if="index == 0">
                  <img :src="item.coverUrl" />
                </div>
                <div v-else>
                  <span
                    style="
                      width: 4px;
                      height: 4px;
                      opacity: 1;
                      position: absolute;
                      top: -3px;
                    "
                    >.</span
                  >
                  <!-- <div class="title3" v-if="index == 1">{{ item.title }}</div> -->
                  <div class="title4">{{ item.title }}</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>
      <common-card :title="demoNewsList.columnName">
        <div class="news" v-if="demoNewsList.newsList">
          <ul>
            <li
              v-for="(item, index) in demoNewsList.newsList.slice(0,6)"
              :key="index"
              @click="detail(item.newsId, demoNewsList.columnPath, item.columnId, 2)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img" style="width: 100%" v-if="index == 0">
                  <img :src="item.coverUrl" />
                </div>
                <div v-else>
                  <span
                    style="
                      width: 10px;
                      height: 10px;
                      opacity: 1;
                      position: absolute;
                      top: -3px;
                    "
                    >.</span
                  >
                  <div class="title4">{{ item.title }}</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>
      <div class="jdmenu"></div>
    </div>
    
    <!--第二行-->
    <div class="jdf2">
      <common-card :title="manageNewsList.columnName">
        <div class="news" v-if="manageNewsList.newsList">
          <ul>
            <li
              v-for="(item, index) in manageNewsList.newsList.slice(0,6)"
              :key="index"
              @click="detail(item.newsId, manageNewsList.columnPath, item.columnId, 3)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img" style="width: 100%" v-if="index == 0">
                  <img :src="item.coverUrl" />
                </div>
                <div v-else>
                  <span
                    style="
                      width: 10px;
                      height: 10px;
                      opacity: 1;
                      position: absolute;
                      top: -3px;
                    "
                    >.</span
                  >
                  <!-- <div class="title3" v-if="index == 1">{{ item.title }}</div> -->
                  <div class="title4">{{ item.title }}</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>

      <common-card :title="elegantNewsList.columnName">
        <div class="news" v-if="elegantNewsList.newsList">
          <ul>
            <li
              v-for="(item, index) in elegantNewsList.newsList.slice(0,6)"
              :key="index"
              @click="detail(item.newsId, elegantNewsList.columnPath, item.columnId, 2)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img" style="width: 100%" v-if="index == 0">
                  <img :src="item.coverUrl" />
                </div>
                <div v-else>
                  <span
                    style="
                      width: 10px;
                      height: 10px;
                      opacity: 1;
                      position: absolute;
                      top: -3px;
                    "
                    >.</span
                  >
                  <!-- <div class="title3" v-if="index == 1">{{ item.title }}</div> -->
                  <div class="title4">{{ item.title }}</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>

      <common-card :title="trainNewsList.columnName">
        <div class="news" v-if="trainNewsList.newsList">
          <ul>
            <li
              v-for="(item, index) in trainNewsList.newsList.slice(0,9)"
              :key="index"
              @click="detail(item.newsId, elegantNewsList.columnPath, item.columnId, 1)"
            >
              <a href="javascript:;" :title="item.title">
                <span
                  style="
                    width: 10px;
                    height: 10px;
                    opacity: 1;
                    position: absolute;
                    top: -3px;
                  "
                  >.</span
                >
                <!-- <div class="title3" v-if="index == 0">
                  {{ item.title }}
                </div> -->
                <div class="title4">{{ item.title }}</div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>
    </div>
    <!--第二个广告位-->
    <div class="jdgg" v-if="banner.length >= 2">
      <a :href="banner[1].bannerUrl" target="_blank">
        <img :src="banner[1].bannerPic" />
      </a>
    </div>
    <!--理论成果-->
    <div class="jdf3">
      <common-card :title="theoreticalList.columnName">
        <div class="news" v-if="theoreticalList.newsList">
          <ul>
            <li
              v-for="(item, index) in theoreticalList.newsList.slice(0,6)"
              :key="index"
              @click="detail(item.newsId, theoreticalList.columnPath, item.columnId, 1)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img" style="width: 100%" v-if="index == 0">
                  <img :src="item.coverUrl" />
                </div>
                <div v-else>
                  <span
                    style="
                      width: 10px;
                      height: 10px;
                      opacity: 1;
                      position: absolute;
                      top: -3px;
                    "
                    >.</span
                  >
                  <!-- <div class="title3" v-if="index == 1">{{ item.title }}</div> -->
                  <div class="title4">{{ item.title }}</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>
      <common-card :title="researchNewsList.columnName">
        <div class="news" v-if="researchNewsList.newsList">
          <ul>
            <li
              v-for="(item, index) in researchNewsList.newsList.slice(0,6)"
              :key="index"
              @click="detail(item.newsId, researchNewsList.columnPath, item.columnId, 2)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img" style="width: 100%" v-if="index == 0">
                  <img :src="item.coverUrl" />
                </div>
                <div v-else>
                  <span
                    style="
                      width: 10px;
                      height: 10px;
                      opacity: 1;
                      position: absolute;
                      top: -3px;
                    "
                    >.</span
                  >
                  <!-- <div class="title3" v-if="index == 1">{{ item.title }}</div> -->
                  <div class="title4">{{ item.title }}</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>
      <common-card :title="experienceNewsList.columnName">
        <div class="news" v-if="experienceNewsList.newsList">
          <ul>
            <li
              v-for="(item, index) in experienceNewsList.newsList.slice(0,10)"
              :key="index"
              @click="detail(item.newsId, experienceNewsList.columnPath, item.columnId, 3)"
            >
              <a href="javascript:;" :title="item.title">
                <span
                  style="
                    width: 10px;
                    height: 10px;
                    opacity: 1;
                    position: absolute;
                    top: -3px;
                  "
                  >.</span
                >
                <!-- <div class="title3" v-if="index == 0">
                  {{ item.title }}
                </div> -->
                <div class="title4">
                  {{ item.title }}
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>
    </div>

    <!--微课堂-->
    <div class="jdf4">
      <div class="jdf4-left" v-if="classroomNewsList.newsList">
        <common-card :title="classroomNewsList.columnName" width="888px">
          <div style="display: flex">
            <div
              style="flex-grow: 1"
              v-for="(item, index) in classroomNewsList.newsList.slice(0,4)"
              :key="index"
              @click="detail(item.newsId, classroomNewsList.columnPath, item.columnId, 1)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img">
                  <img :src="item.coverUrl" />
                </div>
                <div class="txt">{{ item.title }}</div>
              </a>
            </div>
          </div>
        </common-card>

        <common-card :title="silhouetteList.columnName" width="888px">  
          <div style="display: flex" v-if="silhouetteList.newsList">
            <div
              style="flex-grow: 1"
              v-for="(item, index) in silhouetteList.newsList.slice(0,4)"
              :key="index"
              @click="detail(item.newsId, silhouetteList.columnPath, item.columnId, 2)"
            >
              <a href="javascript:;" :title="item.title">
                <div class="img">
                  <img :src="item.coverUrl" />
                </div>
                <div class="txt">{{ item.title }}</div>
              </a>
            </div>
          </div>
        </common-card>
      </div>
      <common-card :title="'新闻视频'">
        <div class="news" v-if="newsVideoList.newsList">
          <ul>
            <li
              v-for="(item, index) in newsVideoList.newsList.slice(0,15)"
              :key="index"
              @click="detail(item.newsId, newsVideoList.columnPath, item.columnId, 3)"
            >
              <a href="javascript:;" :title="item.title">
                <span
                  style="
                    width: 10px;
                    height: 10px;
                    opacity: 1;
                    position: absolute;
                    top: -3px;
                  "
                  >.</span
                >
                
                <div class="title4">
                  {{ item.title }}
                </div>
              </a>
            </li>
          </ul>
        </div>
      </common-card>
    </div>

    <div class="jdf5">
      <common-card
        :title="'相关链接'"
        width="100%"
        style="min-height: 74px !important"
      >
        <div class="link">
          <div v-for="(item, index) in linkList" :key="index">
            <a :href="item.url">{{ item.text }}</a>
          </div>
        </div>
      </common-card>
    </div>
  </div>
</template>

<script>
import CommonCard from "../../components/CommonCard";
import { getHomePageInfo } from "../../api/article";
import { getColumns, getBanner } from "../../api/dictionary";
import _ from "lodash";
export default {
  components: {
    CommonCard,
  },
  data() {
    return {
      // 遮罩层
      loading: false,
      columnIds: "",
      newsList: [],
      bannerList: [],
      rightNewsList: [],
      workNewsList: [],
      demoNewsList: [],
      manageNewsList: [],
      elegantNewsList: [],
      trainNewsList: [],
      theoreticalList: [],
      researchNewsList: [],
      experienceNewsList: [],
      classroomNewsList: [],
      silhouetteList: [],
      newsVideoList: [],
      tabs: [],
      banner: {},
      tabIndex: 0,
      cards: [],
      linkList: [
        { url: "http://www.people.com.cn/", text: "人民网" },
        { url: "http://cpc.people.com.cn/", text: "中国共产党新闻网" },
        { url: "http://www.xinhuanet.com/", text: "新华网" },
        { url: "https://www.12371.gov.cn/", text: "七一网" },
        { url: "http://www.dangjian.cn/", text: "党建网" },
        { url: "http://www.cbt.com.cn/", text: "中华工商网" },
        { url: "https://www.caijing.com.cn/", text: "财经网" },
        { url: "http://www.dongfangdj.gov.cn/", text: "东方党建网" },
        { url: "http://www.zjzzgz.gov.cn/", text: "浙江组织工作网" },
        { url: "http://www.sx-dj.gov.cn/", text: "陕西党建网" },
        {
          url:
            "http://www.ddcpc.cn/index.php?m=content&c=index&a=lists&catid=589",
          text: "贵州先锋网",
        },
        {
          url: "http://www.bjdj.gov.cn/index.html",
          text: "北京组工网",
        },
        {
          url: "http://www.china.com.cn/",
          text: "中国网",
        },
        {
          url: "http://www.ce.cn/",
          text: "中国经济网",
        },
        {
          url: "http://www.lndangjian.org.cn/",
          text: "辽宁党建网",
        },
      ],
    };
  },
  computed: {
    flterPersions() {
      return this.starList.slice(0, 2);
    },
    hotNewsTop() {
      if (this.newsList.length !== 0) {
        return this.newsList[0];
      } else {
        return new Object();
      }
    },
  },
  async created() {
    const [res, res2] = await Promise.all([
      this.getColumns(),
      this.getBanner(),
    ]);
    let ids = [];
    res.rows.forEach(function (item) {
      ids.push(item.id);
    });
    this.columnIds = ids.join(",");
    const res3 = await Promise.all([
      this.getHomePageInfo(),
    ]);
    this.newsList = res3[0];
    _.forEach(res.rows[0].children, (p) => {
      this.tabs.push({ id: p.id, label: p.label });
    });
    if (res2 != null && res2.length != 0) {
      this.banner = res2;
    }
    // 右上角显示数据
    this.rightNewsList = this.findArr(this.tabs[0].id);  
    // 综合工作
    this.workNewsList = this.findArr(31);
    // 师范推广
    this.demoNewsList = this.findArr(32);
    // 监督管理
    this.manageNewsList = this.findArr(20);
    // 企业风采
    this.elegantNewsList = this.findArr(19);
    // 云端培训
    this.trainNewsList = this.findArr(18);
    // 理论成果
    this.theoreticalList = this.findArr(24);
    // 调研活动
    this.researchNewsList = this.findArr(25);
    // 经验交流
    this.experienceNewsList = this.findArr(26);
    // 微课堂
    this.classroomNewsList = this.findArr(27);
    // 党建建材
    this.silhouetteList = this.findArr(28);
    // 新闻视频
    this.newsVideoList = this.findArr(29);
    
  },
  methods: {
    detail(id, path, columnId, tabIndex) {
      var obj = JSON.stringify({ newsId: id, columnId: columnId, tabIndex: tabIndex});
      localStorage.setItem("SET_HOMENEWS", obj);
      this.$router.push(path);
    },
    async enter(id, index) {
      this.tabIndex = index;
      this.itemType = index + 1;
      this.rightNewsList = this.findArr(id);
    },
    // 查找数组
    findArr(id) {
      let tempArr = [];
      for (let i = 0;i < this.newsList.length; i++) {
        if (this.newsList[i].id == id) {
            tempArr.push(this.newsList[i]);
        }
      }
      return tempArr[0];
    },
    sliceStr(value) {
      if (value.length > 55) {
        let str = value.slice(0, 39);
        return `${str}...`;
      } else {
        return value;
      }
    },
    async getBanner() {
      let result = await getBanner({
        platform: 1,
      });
      return result.data;
    },
    
    async getColumns() {
      let result = await getColumns();
      return result.data;
    },
    async getHomePageInfo() {
      this.loading = true;
      let result = await getHomePageInfo({
        rowCount: 14,
        columnIds: this.columnIds,
      });
      setTimeout(() => {
        this.loading = false;
      }, 500);
      // this.loading = false;
      return result.data;
    },
  },
};
</script>


<style lang="less" scoped>
.main {
  width: 100%;
  position: relative;
  .jdf1,
  .jdf2,
  .jdf3,
  .jdf4,
  .jdf5 {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 30px;
    flex-wrap: wrap;
    .link {
      width: 100%;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      font-size: 16px;

      a {
        color: #555555;
      }
    }
    .box {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      position: relative;
      .arrow {
        position: absolute;
        width: 10px;
        height: 17px;
        top: 40%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .left {
        left: 0;
      }
      .right {
        right: 0;
      }
      .img-box {
        width: 160px;
        margin-top: 20px;
        a {
          color: #333333;
        }
        .img {
          width: 160px;
          height: 224px;
          position: relative;
        }
      }
    }

    .jdmenu {
      width: 432px;
      height: 400px;
      background: url("../../assets/home.png") no-repeat;
      background-size: 432px 400px;
      text-align: center;
      position: relative;
      .menu-btn {
        width: 324px;
        height: 40px;
        background: #cc3333;
        border-radius: 10px;
        margin: auto;
        margin-top: 20px;
        color: #ffffff;
        text-align: center;
        font-size: 18px;
        line-height: 40px;
      }
    }
    .news {
      // position: relative;
      // overflow: hidden;
      a {
        color: #323232;
        // display: inline-block;
        // white-space: nowrap;
      }
      // a:hover {
      //   animation: move 1.5s infinite alternate linear;
      // }
      // @keyframes move {
      //     0% {
      //         transform: translate(0, 0);
      //     }
      //     100% {
      //         transform: translate(calc(-100% + 150px), 0);
      //     }
      // }

    }

    .title4 {
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      font-size: 18px;
      margin-left: 15px;
      margin-top: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //需要控制的文本行数
      overflow: hidden;
      text-overflow: ellipsis;
      // white-space: nowrap;
      position: relative;
    }
    .title3 {
      margin-top: 10px;
      margin-left: 15px;
      font-size: 20px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //需要控制的文本行数
      overflow: hidden;
      white-space: nowrap;
    }
    ul {
      margin: 0;
      padding: 5px;
      li {
        position: relative;
        list-style: none;
      }
    }

    .silhouette {
      width: 100%;
      display: flex;
      .silhouette-image1 {
        width: 592px;
        height: 448px;
      }
      .silhouette-image2 {
        width: 296px;
        height: 216px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .news-video {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-bottom: 32px;
      .news-txt {
        width: 100%;
        .news-title {
          font-weight: bold;
          color: #333333;
          font-size: 20px;
        }
        .news-content {
          //margin-top: 14px;
          color: #555555;
          font-size: 16px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; //需要控制的文本行数
          overflow: hidden;
          max-height: 80px;

          // text-overflow: ellipsis;
          word-break: break-all;
          line-height: 30px;
          img {
            display: none !important;
          }
        }
      }
      .news-image {
        width: 184px !important;
        height: 128px;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .img {
      width: 210px;
      height: 160px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .txt {
      width: 210px;
      color: #555555;
      line-height: 24px;
      font-size: 16px;
      margin-top: 16px;
      margin-bottom: 30px;
    }
  }
  .jdgg {
    width: 100%;
    height: 120px;
    margin: 40px auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .jdbox {
    .jdcontent {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .news {
        width: 664px;
        margin-left: 24px;
        .tab-content {
          width: 100%;
          padding-left: 12px;
          padding-right: 12px;
          .sub-content {
            a {
              color: #323232;
              display: -webkit-box;
              word-break:keep-all;
              white-space:nowrap;
              overflow:hidden;
              text-overflow:ellipsis;
            }
            h3,
            h4 {
              margin: 0;
            }
            h3 {
              margin-top: 30px;
              font-size: 20px;
            }
            h4 {
              margin: 0;
              margin-top: 13px;
              color: rgba(85, 85, 85, 1);
              font-size: 18px;
            }
          }
        }
        .tab {
          width: 100%;
          height: 48px;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          background-color: #ededed;
          line-height: 48px;
          vertical-align: middle;

          .active {
            background-color: #cb3333;
            color: #ffffff;
          }
          .sub-tab {
            width: 33.3%;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
      .img {
        height: 416px;
        width: 688px;
        position: relative;
        .mask1 {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 48px;
          opacity: 0.7;
          background-color: #000000;
          text-align: center;
          color: #ffffff;
          font-size: 20px;
          font-weight: 400;
          line-height: 52px;
          vertical-align: middle;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .jdsub {
      margin: 25px auto 30px auto;
      text-align: center;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //需要控制的文本行数
      overflow: hidden;
      width: 90%;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(101, 101, 101, 1);
      line-height: 19px;
      height: 19px;
      a {
        color: rgba(101, 101, 101, 1);
      }
    }
    .jdtop {
      text-align: center;
      margin: 0 auto 40px auto;
      width: 1219px;
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 52px;

      a {
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
</style>